import { render, staticRenderFns } from "./shopBreadcrumbNav.vue?vue&type=template&id=4883e80c&scoped=true"
import script from "./shopBreadcrumbNav.vue?vue&type=script&lang=js"
export * from "./shopBreadcrumbNav.vue?vue&type=script&lang=js"
import style0 from "./shopBreadcrumbNav.vue?vue&type=style&index=0&id=4883e80c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4883e80c",
  null
  
)

export default component.exports